import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Style from "./ticketCancellationRequestModal.module.css";
import Button from "../../common/button/button";
import { switchLegalStatus, switchStatus } from "../../utils/ticketStatusesHelper";
import ModalAddComment from "../violations/modalAddComment";
import {
  approveTicketCancellationRequest,
  denyTicketCancellationRequest,
} from "../../actions/ticketCancellationRequest";
import {
    commentTicket
} from "../../actions/violations";
import EntityDetail from "./entityDetail";
import { newModalStyle } from "../../reusable/styles";
import { useState } from "react";
import ViolationsDetailsModal from "../violations/violationsDetailsModal";
import OwnerDetailsModal from "../owner/ownerDetailsModal";
import Comment from "../../common/assets/comment.svg";


const TicketCancellationRequestModal = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [openTicketModal, setOpenTicketModal] = useState(false);
  const [openOwnerModal, setOpenOwnerModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState("");
  const [selectedOwner, setSelectedOwner] = useState("");
  const [commentDefaultValue, setCommentDefaultValue] = useState("");
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [ticketNumberInCommentModal, setTicketNumberInCommentModal] = useState(false);


  const toogleModalForComment = () => {
    setCommentDefaultValue("");
    setOpenCommentModal(!openCommentModal);
  };

  const addComment = async (data) => {
    const dataForEdit = {
      ticketNumber: ticketNumberInCommentModal,
      comment: data.comment,
    };

    await dispatch(commentTicket(dataForEdit));
    toogleModalForComment();
  };

  const onClose = () => {
    props.setModalOpen(false);
  };

  const { ticketCancelationRequest } = useSelector(
    (state) => state.ticketCancellationRequests
  );
  const isGasStationTicket = ticketCancelationRequest?.ticket?.gasStationZone;

  const keepTicket = (id) => {
    dispatch(denyTicketCancellationRequest(id, props.setErrorModalOpen));
    onClose();
  };

  const cancelTicket = (id) => {
    dispatch(approveTicketCancellationRequest(id, props.setErrorModalOpen));
    onClose();
  };

  return (
  <div>
    {openCommentModal && (
      <ModalAddComment
        open={openCommentModal}
        addComment={addComment}
        close={toogleModalForComment}
        defaultValue={commentDefaultValue}
      />
    )}
    <Modal
      open={props.open}
      closeOnEsc
      onClose={onClose}
      center
      styles={newModalStyle({ width: "539px" })}
    >
      <div className="modal__headerLine" />
      <div className="modal__title">
        {ticketCancelationRequest?.ticket?.parkingZone
          ? t("ticketCancellationRequestModal.titleParkingZone")
          : t("ticketCancellationRequestModal.titleGasStation")}
      </div>

      <div className={Style.body}>
        <EntityDetail
          label={t("ticketCancellationRequestModal.reference")}
          value={ticketCancelationRequest?.ticket?.number}
          pressableValue={!isGasStationTicket}
          openModal={setOpenTicketModal}
          setSelectedTicket={() => {
            setSelectedTicket(ticketCancelationRequest.ticket);
          }}
        />
        <EntityDetail
                  label={t("Columns.Status")}
                  value={switchStatus(t, ticketCancelationRequest?.ticket)}
        />
        <EntityDetail
                  label={t("Columns.LegalStatus")}
                  value={switchLegalStatus(t, ticketCancelationRequest?.ticket?.legalStatus)}
        />
        <EntityDetail
          label={t("ticketCancellationRequestModal.dateOfRequest")}
          value={moment(ticketCancelationRequest?.createdOn).format(
            "DD.MM.YYYY"
          )}
        />
        <EntityDetail
          label={t("ticketCancellationRequestModal.timeOfRequest")}
          value={moment(ticketCancelationRequest?.createdOn).format("HH:mm")}
        />
        <EntityDetail
          label={t("ticketCancellationRequestModal.requestor")}
          value={ticketCancelationRequest?.requestor?.beppoOfficerData}
          pressableValue
          openModal={setOpenOwnerModal}
          setSelectedTicket={() => {
            setSelectedOwner(ticketCancelationRequest?.requestor);
          }}
        />
        <EntityDetail
          label={t("ticketCancellationRequestModal.beppoliceman")}
          value={ticketCancelationRequest?.beppoliceman?.beppoOfficerData}
          pressableValue
          openModal={setOpenOwnerModal}
          setSelectedTicket={() => {
            setSelectedOwner(ticketCancelationRequest?.beppoliceman);
          }}
        />
        <EntityDetail
          label={t("ticketCancellationRequestModal.justification")}
          value={t(`CancellationReasons.${ticketCancelationRequest?.cancellationReason}`)}
        />
        <EntityDetail
                  label={t("Columns.Comment")}
                  value={    <img
                                src={Comment}
                                style={{ cursor: "pointer", paddingLeft: 30 }}
                                id="comment"
                                alt="comment"
                                height={20}
                                onClick={() => {
                                                toogleModalForComment();
                                                setCommentDefaultValue(ticketCancelationRequest?.ticket?.comment);
                                                setTicketNumberInCommentModal(ticketCancelationRequest?.ticket?.number);
                                }}
                             />
                  }
        />
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          text={t("ticketCancellationRequestModal.accept")}
          buttonStyle={{
            marginBottom: "20px",
            marginTop: "20px",
            height: "40px",
            width: "210px",
            fontFamily: "Gilroy-Regular",
            marginRight: "28px",
          }}
          onClick={() => {
            cancelTicket(ticketCancelationRequest?.id);
          }}
        />
        <Button
          text={t("ticketCancellationRequestModal.reject")}
          buttonStyle={{
            marginBottom: "20px",
            marginTop: "20px",
            height: "40px",
            width: "210px",
            marginRight: "10px",
            backgroundColor: "#CC0605",
            fontFamily: "Gilroy-Regular",
          }}
          onClick={() => keepTicket(ticketCancelationRequest?.id)}
        />
      </div>
      {openTicketModal && (
        <ViolationsDetailsModal
          title={t("ticketCancellationRequestModal.titleParkingZone")}
          open={openTicketModal}
          setModalOpen={setOpenTicketModal}
          selectedTicket={selectedTicket}
          onClose={() => {
            setOpenTicketModal(false);
            setSelectedTicket("");
          }}
        />
      )}
      {openOwnerModal && (
        <OwnerDetailsModal
          open={openOwnerModal}
          setModalOpen={setOpenOwnerModal}
          owner={selectedOwner}
          onClose={() => {
            setOpenOwnerModal(false);
            setSelectedOwner("");
          }}
        />
      )}
    </Modal>
   </div>
  );
};
export default TicketCancellationRequestModal;
